module.exports = __webpack_public_path__ + "static/media/freestandinghouse.1d386363.png";